import { xhr } from '@/api/config/Repository'
import UserAccessDataRepository from '../UserAccessDataRepository'
import UserAccessDataResponse from '@/services/userAccessData/models/UserAccessDataResponse'
import UserAccessDataResponseDTO from '../dto/UserAccessDataResponseDTO'
import UserAccessPermissionsDataResponse from '@/services/userAccessData/models/UserAccessPermissionsDataResponse'
import UserAccessPermissionsDataResponseDTO from '../dto/UserAccessPermissionsDataResponseDTO'
import EditUserPermissionsRequestDTO from '../dto/EditUserPermissionsRequestDTO'
export default class UserAccessDataRepositoryImpl implements UserAccessDataRepository {
  getDefaultHeaders (): any {
    return {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Accept-Language': 'es'
    }
  }

  async getUserAccessData (): Promise<UserAccessDataResponse> {
    const endpoint = 'user/access'
    const headers = this.getDefaultHeaders()
    const response = await xhr.get<UserAccessDataResponseDTO>(endpoint, { headers })
    return {
      data: response.data.data,
      status: response.status,
      totalCount: response.data.totalCount
    }
  }

  async getUserAccessPermissionsData (): Promise<UserAccessPermissionsDataResponse> {
    const endpoint = 'user/permission'
    const headers = this.getDefaultHeaders()
    const response = await xhr.get<UserAccessPermissionsDataResponseDTO>(endpoint, { headers })
    return {
      data: response.data.data,
      status: response.status,
      totalCount: response.data.totalCount
    }
  }

  async getViewUserPermissionData (userType: string, userRole: string): Promise<UserAccessPermissionsDataResponse> {
    const endpoint = `user/viewUserPermission?userType=${userType}&userRole=${userRole}`
    const headers = this.getDefaultHeaders()
    const response = await xhr.get<UserAccessPermissionsDataResponseDTO>(endpoint, { headers })
    return {
      data: response.data.data,
      status: response.status,
      totalCount: response.data.totalCount
    }
  }

  async editUserPermissionsData (request: EditUserPermissionsRequestDTO): Promise<UserAccessPermissionsDataResponse> {
    const endpoint = 'user/editUserPermission'
    const headers = this.getDefaultHeaders()
    const response = await xhr.put<EditUserPermissionsRequestDTO, UserAccessPermissionsDataResponse>(endpoint, request, { headers })
    return {
      message: response.data.message,
      status: response.status
    }
  }
}
